/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import {
  CmsBannerComponent,
  CmsService,
  Image,
  ImageGroup,
  PageType,
  SemanticPathService,
} from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { CmsComponentData } from '../../../cms-structure/page/model/cms-component-data';

@Component({
  selector: 'cx-banner',
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  routerLink: string | any[] | undefined;

  @HostBinding('class') styleClasses: string | undefined;

  data$: Observable<CmsBannerComponent> = this.component.data$.pipe(
    tap((data) => {
      this.setRouterLink(data);
      this.styleClasses = data?.styleClasses;
    })
  );

  constructor(
    protected component: CmsComponentData<CmsBannerComponent>,
    protected urlService: SemanticPathService,
    protected cmsService: CmsService
  ) {}

  /**
   * Returns `_blank` to force opening the link in a new window whenever the
   * `data.external` flag is set to true.
   */
  getTarget(data: CmsBannerComponent): string | null {
    return data.properties?.external === 'true' || data.properties?.external === true ? '_blank' : null;
  }

  protected setRouterLink(data: CmsBannerComponent): void {
    if (data?.properties?.urlLink) {
      this.routerLink = data.properties?.urlLink;
    } else if (data?.properties?.contentPage) {
      this.cmsService
        .getPage({
          id: data.properties?.contentPage,
          type: PageType.CONTENT_PAGE,
        })
        .pipe(take(1))
        .subscribe((page) => {
          this.routerLink = page?.label;
        });
    } else if (data?.properties?.product) {
      this.routerLink = this.urlService.transform({
        cxRoute: 'product',
        params: { code: data.properties?.product },
      });
    } else if (data?.properties?.category) {
      this.routerLink = this.urlService.transform({
        cxRoute: 'category',
        params: { code: data.properties?.category },
      });
    }
  }

  getImage(data: CmsBannerComponent): Image | ImageGroup | undefined {
    if (data.properties?.media) {
      if ('url' in (data?.properties?.media ?? {})) {
        return data.properties?.media as Image;
      } else {
        return data.properties?.media as ImageGroup;
      }
    }
  }
}
